import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getVehicleTotalPrice } from 'Components/vehicle/ducks/selectors';
import {
  getVehicleLock,
  getUserLoggedInStatus,
  getVehicle
} from 'Components/app/ducks/selectors';
import { getChatContext, getIsMobile, getOrderState } from './ducks/selectors';
import { getNavigationConfig } from '../../../dashboard/ducks/selectors';
import Header from './header';

const mapStateToProps = state => ({
  isLoggedIn: getUserLoggedInStatus(state),
  vehicleTotalPrice: getVehicleTotalPrice(state),
  chatContext: getChatContext(state),
  vehicleLock: getVehicleLock(state),
  navigationConfig: getNavigationConfig(state),
  vehicle: getVehicle(state),
  isMobile: getIsMobile(state),
  orderState: getOrderState(state)
});

export default compose(
  withRouter,
  connect(mapStateToProps)
)(Header);
